import { Auth } from "aws-amplify";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import { useTranslation } from "react-i18next";

function VerficationModal({
  email,
  cb,
  verificationLoading,
  verify,
  isVerificationVisible,
  setIsVerificationVisible,
}: any) {
  const { t, i18n } = useTranslation();
  const intervalRef = useRef<any>();
  const [showResendTime, setShowResendTime] = useState<number>(
    Date.now() + 60 * 1000
  );
  const [showResend, setShowResend] = useState(false);

  useEffect(() => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      if (showResendTime < Date.now()) {
        setShowResend(true);
      } else {
        setShowResend(false);
      }
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [showResendTime]);

  const { handleSubmit, register, errors } = useForm({
    defaultValues: {
      verificationCode: "",
    },
  });

  const onSubmit = handleSubmit(({ verificationCode }) =>
    verify(email, verificationCode, cb)
  );

  return (
    <Fragment>
      <div
        className={`modal fade ${isVerificationVisible ? "show" : ""}`}
        id="verify_modal"
        style={{ display: isVerificationVisible ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content border-0">
            <div className="modal-body p-3 p-md-5 custom_modal">
              <div className="">
                <form>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''} mb-4`}>
                    <label className="mb-0">
                      {t('Please enter the verification code sent on your email address')}
                    </label>
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''} mb-4`}>
                    {/* <label>{t('Verification Code')}</label> */}
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter Verification Code")}
                      name={"verificationCode"}
                      ref={register({
                        required: {
                          value: true,
                          message: t("Verfication code is required"),
                        },
                        pattern: {
                          value: /^[0-9]{6}$/,
                          message: t("Verification code is invalid"),
                        }
                      })}
                    />
                    <VisibilityToggle
                      visible={errors.verificationCode ? true : false}
                    >
                      <p className="text-danger">
                        {errors.verificationCode?.message}
                      </p>
                    </VisibilityToggle>
                  </div>
                  <VisibilityToggle visible={showResend}>
                    <div className="form-group mb-2">
                      <label
                        className="text-primary mb-0"
                        onClick={() => {
                          setShowResendTime(Date.now() + 60 * 1000);
                          Auth.resendSignUp(email);
                        }}
                      >
                        {t('Resend Code')}
                      </label>
                    </div>
                  </VisibilityToggle>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className={`btn custom_btn border text-secondary bg-transparent fz14 ${i18n.dir() === "rtl" ? "ml-3" : "mr-3"}`}
                      onClick={() => setIsVerificationVisible(false)}
                    >
                      {t('Cancel')}
                    </button>
                    <button
                      disabled={verificationLoading}
                      type="button"
                      className="btn custom_btn fz14"
                      onClick={onSubmit}
                    >
                      <VisibilityToggle visible={verificationLoading}>
                        <span className="spinner-border spinner-border-sm"></span>
                        &nbsp;
                      </VisibilityToggle>
                      {t('Verify')}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={isVerificationVisible}>
        <div
          className={`modal-backdrop fade ${isVerificationVisible ? "show" : ""
            }`}
        ></div>
      </VisibilityToggle>
    </Fragment>
  );
}

export default VerficationModal;
